import axios from "axios";
import Cookies from "js-cookie";
import { useState } from "react";

export default function DetailsTable({ data, setData, forceUpdate }) {
	const [loading, setLoading] = useState(false);

	const handleChange = ({ target, file }) => {
		const { value, name } = target,
			index = target?.dataset?.index;
		console.log("name >>>", name);

		setData(rows => {
			rows[parseInt(index)] = { ...rows?.[index], [name]: value, file };
			return rows;
		});
		forceUpdate();
	};

	const handleUpload = async event => {
		setLoading(true);
		const file = event.target.files[0];

		const formData = new FormData();
		formData.append(`file`, file);

		await axios
			.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
				headers: {
					Authorization: `Bearer ${Cookies.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(function (res) {
				let eventTmp = {
					...event?.target,
					dataset: event?.target?.dataset,
					name: event?.target?.name,
				};
				eventTmp.value = `${process.env.REACT_APP_MAIN_URL}${res?.data?.data?.file?.path}`;

				handleChange({ target: eventTmp, file: res?.data?.data?.file });
			})
			.catch(function (error) {
				setLoading(false);
			});

		setLoading(false);
	};

	const handleRemove = index => {
		setData(rows => rows?.filter((_, i) => i !== index));
		forceUpdate();
	};

	const handleDownload = async (url, filename) => {
		const response = await fetch(url);
		const blob = await response.blob();
		const blobUrl = window.URL.createObjectURL(blob);

		const link = document.createElement("a");
		link.href = blobUrl;
		link.setAttribute("download", filename);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		window.URL.revokeObjectURL(blobUrl);
	};
	return (
		<div>
			<div className="overflow-auto d-flex flex-column gap-4 p-3 my-4 card">
				<h3>جدول التفاصيل</h3>
				<table className="details-table">
					<thead>
						<tr>
							<td rowspan="2"></td>
							<td rowspan="2" width="82">
								Genset Type
							</td>
							<td rowspan="2" width="149">
								Engine
							</td>
							<td rowspan="2" width="127">
								Alternator
							</td>
							<td colspan="2" width="128">
								Prime
							</td>
							<td colspan="2" width="128">
								Standby
							</td>
							<td rowspan="2" width="128">
								File
							</td>
						</tr>
						<tr>
							<td>kVA</td>
							<td>KW</td>
							<td>kVA</td>
							<td>KW</td>
						</tr>
					</thead>
					<tbody>
						{data.map((item, index) => (
							<tr key={index}>
								<td>
									<button
										type="button"
										onClick={() => handleRemove(index)}
										className="text-danger"
									>
										X
									</button>
								</td>
								<td>
									<input
										data-index={index}
										value={item?.genset}
										name="genset"
										onChange={handleChange}
									/>
								</td>

								<td>
									<input
										data-index={index}
										value={item?.engine}
										name="engine"
										onChange={handleChange}
									/>
								</td>
								<td>
									<input
										data-index={index}
										value={item?.alterator}
										name="alterator"
										onChange={handleChange}
									/>
								</td>
								<td>
									<input
										data-index={index}
										value={item?.prime}
										name="prime_kva"
										onChange={handleChange}
									/>
								</td>
								<td>
									<input
										data-index={index}
										value={item?.prime}
										name="prime_kw"
										onChange={handleChange}
									/>
								</td>
								<td>
									<input
										data-index={index}
										value={item?.standby}
										name="standby_kva"
										onChange={handleChange}
									/>
								</td>
								<td>
									<input
										data-index={index}
										value={item?.standby}
										name="standby_kw"
										onChange={handleChange}
									/>
								</td>
								<td>
									<div className="d-flex justify-content-between align-items-center p-1">
										{item?.file ? (
											<>
												<a
													// href={`${process.env.REACT_APP_MAIN_URL}${item?.file?.path}`}
													// target="_blank"
													// download={item?.file?.originalname}

													href="#"
													onClick={e => {
														e.preventDefault();
														handleDownload(
															process.env.REACT_APP_MAIN_URL + item?.file?.path,
															item?.file?.originalname
														);
													}}
												>
													عرض الملف
												</a>
												<button
													type="button"
													onClick={() =>
														handleChange({
															target: {
																dataset: { index },
																name: "file",
																value: undefined,
															},
														})
													}
												>
													X
												</button>
											</>
										) : (
											<input
												data-index={index}
												type="file"
												name="file"
												onChange={handleUpload}
											/>
										)}
										{loading && "جاري الرفع..."}
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>
				<button
					onClick={() => setData(rows => [...rows, {}])}
					type="button"
					className="bt bt-success"
				>
					اضف صف
				</button>

				<style>
					{`
          .details-table{
              width:100%;
              border: 1px solid #dfdfdf;
          }
          .details-table thead {
            background-color: #fd9816;
            font-weight: bold;
          }
         
          .details-table td{
            border: 1px solid #dfdfdf;
            padding: 10px;
            text-align: center;
          }
          .details-table input{
              border:1px solid #ccc;
              border-radius:5px;
              padding:5px;
              width:100%;
              min-width:65px;
          }
        `}
				</style>
			</div>
		</div>
	);
}
